import styled from "styled-components";

const StyledSpan = styled.span`
  font-size: 0.725rem;
  width: calc(100% - 30px);
  max-width: fit-content;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export default StyledSpan;

